import * as Sentry from "@sentry/react";

export async function handleError(e) {
  console.error(e);
  Sentry.captureException(e);
}
